import axiosInstance from "./axios.instance";

const API_GET_ALL_IPCONFIGS = async () => {
  try {
    const resp = await axiosInstance.get(`/ip`);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_ADD_IPCONFIG = async (ipConfigData) => {
  try {
    const resp = await axiosInstance.put(`/ip`, ipConfigData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_UPDATE_IPCONFIG = async (id, ipConfigData) => {
  try {
    const resp = await axiosInstance.put(`/ip/${id}`, ipConfigData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_DELETE_IPCONFIG = async (id) => {
  try {
    await axiosInstance.delete(`/ip/${id}`);
    return id;
  } catch (err) {
    throw err;
  }
};

export {
  API_GET_ALL_IPCONFIGS,
  API_ADD_IPCONFIG,
  API_UPDATE_IPCONFIG,
  API_DELETE_IPCONFIG,
};
